import { Skeleton } from "@mui/material";
import {
	ImageSkeleton,
	SkeletonDetails,
	SkeletonWrapper
} from "features/MarketingMaterials/pages/ItemDetails/components/ItemDetailsSkeleton.styles.ts";

export const ItemDetailsSkeleton = () => {
	return (
		<SkeletonWrapper data-testid="item-details-skeleton">
			<ImageSkeleton
				variant="rectangular"
				height="432px"
				width="500px"
			/>
			<SkeletonDetails>
				<Skeleton
					variant="rectangular"
					height="56px"
				/>
				<Skeleton
					variant="rectangular"
					height="16px"
				/>
				<Skeleton
					variant="rectangular"
					height="16px"
				/>
				<Skeleton
					variant="rectangular"
					height="56px"
				/>
				<Skeleton
					variant="rectangular"
					height="56px"
				/>
				<Skeleton
					variant="rectangular"
					height="16px"
					width="180px"
				/>
			</SkeletonDetails>
		</SkeletonWrapper>
	);
};
